/* MV Sortiment assets/mv-sortiment.finder.js · Agent T-F · 2026-10-02 */
/*
  Automaten-Finder (Plan P8 "Finder", Anhang A 2.17 FIND-Q/FIND-R, Z-08).

  Teil 1 - reine Logik ohne DOM: Kriterien lesen/schreiben, Produkte normalisieren, Matching, Ergebnistext.
           Unter Node (kein window) landen diese Funktionen auf module.exports (_tests/finder.test.mjs).
  Teil 2 - Browser: Waechter window.__mvSortiment.finder, Delegation auf document, Schritte, URL-Zustand
           per history.replaceState, Ergebniskarten aus <template>, Analytics (finder_schritt, finder_ergebnis,
           finder_cta) und das Ereignis mv:finder:ergebnis.

  Matching (Vertrag, _docs/finder.md):
  - Pflichtfilter Standort und Sortiment. Sortiment snack = typ snack + tisch (ohne Kaffee-Tischgeraete),
    getraenke/tiefkuehl/kaffee/micro-market = gleichnamiger Typ, kombi = typ kombi (Rang 0) plus G-Snack-Master
    (Rang 1) mit Hinweis auf einen G-Drink-Slave am selben Standort; ohne solchen Slave seit Paket KX-1 der Ersatz
    als ein Geraet (Punkt KX-1 unten).
  - Agent F-2 (2026-10-08, Inhaber: "Wenn ich Innen, Snack und Getraenke, Gross waehle warum erscheint der X10
    nicht??"): kombi zaehlt auch die Familie x10 als direkten Treffer (Rang 0), denn der X10 verkauft Snacks und
    Getraenke in einem Geraet, traegt im Katalog aber typ:snack (die Produkt-Tags bleiben). Er steht vor den
    uebrigen Treffern gleichen Rangs (Vorzug), ausser bei Bedienung "tasten": dort entscheidet der Score, das
    Combi-Geraet mit Tasten bleibt vorn und der X10 wird Alternative. Sein Grund im Ergebnistext ist
    TEXTE.grundEinGeraet statt der Vorteile. Die Sektion ergaenzt im Datenblock zusaetzlich typ:kombi (doppelt
    abgesichert, _docs/f2-finder-x10.md).
  - Paket KX-1 (2026-10-13, Inhaber zu Aussen + Snacks und Getraenke: "Warum gibt es da keine Empfehlung?"): Fuer
    draussen gibt es keinen G-Drink-Slave, der Ersatz fiel deshalb weg und das Ergebnis war nur die Beratung. Ohne
    G-Drink-Slave am Standort greift der Ersatz jetzt als ein Geraet: der G-Snack-Master verkauft Snacks und Getraenke
    (Dosen und PET-Flaschen in Dosenhaltern), Grund TEXTE.grundEinGeraetErsatz statt der Vorteile, Hinweis auf einen
    Slave der Familie ersatz.auswahlSlaveFamilie am selben Standort (TEXTE.auswahlSlaveVor; nicht bei "Spaeter
    erweitern: nein", derselbe Slave nur einmal). Bei Groesse ersatz.daneben.groesse ("gross") steht als zweite Karte
    der passendste Master aus ersatz.daneben (Getraenke, Familie g-drink) derselben Lage daneben (Rang 2, daneben:
    true; Zusatz TEXTE.daneben im Ergebnistext, Hinweis TEXTE.danebenVor auf der Karte). Mit G-Drink-Slave am Standort
    (innen) unveraendert; die Groesse waehlt auch beim Ersatz die Variante wie bei direkten Treffern.
    Doku: _docs/kx1-extras-finder.md.
  - Empfohlen werden nur Produkte mit Tag rolle:master (Vertrag 02.10.; X10 bekommt den Tag im Liquid),
    nie typ erweiterung/zahlungssystem/zubehoer/service. Slaves dienen nur als Hinweis.
  - Paket F-6 (2026-10-14, Inhaber dreimal: "Warum kein X10" / "Warum findet man im Automatenfinder immer noch
    nirgendwo unseren X10?"): Bei Standort Innen ist der X10 (Regel immer, Familie x10) bei Snacks und bei Snacks
    und Getraenken immer eine der MAX_TREFFER Karten. Bei Snacks hat er den Vorzug, wenn die Groesse passt und
    Bedienung nicht "tasten" ist (immerVorzug), und traegt wie bei kombi den Grund TEXTE.grundEinGeraet. Steht er
    sonst nicht unter den Karten, nimmt er die letzte Stelle: die uebrigen behalten ihre Reihenfolge, der bisher
    letzte Treffer faellt heraus (mitImmer); steht er schon darunter, bleibt seine Stelle. "touch" filtert wie
    bisher, aussen ist der X10 kein Kandidat, die acht Farben zaehlen weiter einmal. Abschaltbar mit
    optionen.x10Immer === false (Setting x10_immer der Sektion, Attribut data-x10-immer): dann genau wie vor F-6.
    Doku: _docs/f6-finder-x10-innen.md.
  - Paket F-7 (2026-10-14, Inhaber zum Ergebnis: "Geb auf den Seiten keine Hauptempfehlung sondern immer 3"): Das
    Ergebnis zeigt gleichwertige Karten in der Reihenfolge der Bewertung - keine Rolle Empfehlung/Alternative (kein
    Feld rolle, kein Reiter, keine hervorgehobene erste Karte), ueber den Karten der Satz TEXTE.satzEins bzw.
    TEXTE.satzMehr ("Zu Ihren Angaben passen diese drei Automaten.") und der Paket-Satz, wenn jede Karte das
    Komplettpaket hat. Jede Karte zeigt ihre eigenen Fakten als Haken (fakten(): Grund des Treffers aus F-2, F-6 oder
    KX-1, sonst die Vorteile, sonst bei einer Familie einGeraet - dem X10 - TEXTE.grundEinGeraet). Auffuellen: Hat das
    Ergebnis weniger als MAX_TREFFER Karten, kommen Geraete dazu, die nur der Filter Bedienung "touch" ausschloss
    (gleicher Standort, gleiches Sortiment, normale Bewertung; Feld aufgefuellt, Hinweis TEXTE.ohneTouch auf der
    Karte); hat der Bestand fuer Standort und Sortiment weniger Geraete, bleiben es weniger Karten. Bilder: srcset bis
    1200 px aus der Adresse im Datenblock (bildSrcset, BILD_BREITEN), Herstellerfotos mit breitem Weissrand (Feld
    bild_rand) vergroessert die Buehne (data-mv-finder-bildrand). Doku: _docs/f7-finder-drei-karten.md.
  - Bedienung "touch" filtert (nur Touch-Geraete), "tasten" bevorzugt nur (Touch-Geraete bleiben Alternative),
    "egal" wertet nicht. Score = Bedienung passt (2) + Groesse passt (2).
  - Groesse waehlt die Variante: Bucket S/M/L ueber variant.auswahlen (S < schwelle_s, M bis schwelle_l, L darueber);
    passende Variante, sonst die naechstgelegene; innerhalb gleich weit die verfuegbare und guenstigere.
  - Reihenfolge: Rang, Vorzug (F-2), Score absteigend, Groessenabstand, Preis aufsteigend, Datenreihenfolge.
    Farbgeschwister (gleiche Familie, gleiche Variantenliste, z. B. die acht X10-Farben) zaehlen einmal.
  - Optionale Antworten steuern nur den Paket-Satz (bargeld) und den Slave-Hinweis (erweitern, Quelle mv_vending.slave_produkt).
  - Ergebnistext nach FIND-R; Zahlen kommen nur aus Titel, Variante, Modellcode und Vorteilen der Daten
    (der Grund der Regel kombi fuer den X10 enthaelt keine Zahl).
  - Agent D3-R (2026-10-05), Inhaber: die Preise sind Verkaufspreise. Die Karte zeigt den Preis ohne Zusatz;
    die Normalisierung liest keinen Preisstatus mehr, die Kartenvorlage hat keinen Slot dafuer.
  - Paket E-L-2a (2026-10-12, _docs/el2-energielabel-theme.md, Delegierte VO (EU) 2019/2018 Anhang VIII): traegt
    eine Variante im Datenblock das Objekt energie (sections/mv-finder.liquid), behaelt die Normalisierung es unveraendert
    (ohne energie bleibt das Variantenobjekt wie bisher); die Karte haengt Klassenpfeil und Link "Produktdatenblatt" als
    Knoten in den Platz [data-mv-energie-finder] (window.__mvSortiment.energielabel.karteKnoten aus
    assets/mv-sortiment.energielabel.js, im Buendel vor dieser Datei; kein innerHTML hier) oder entfernt ihn.
*/
(function () {
  'use strict';

  // ===========================================================================================
  // Teil 1: Logik
  // ===========================================================================================

  var FELDER = ['standort', 'sortiment', 'groesse', 'bedienung', 'bargeld', 'erweitern'];
  var PFLICHT = ['standort', 'sortiment', 'groesse', 'bedienung'];
  var ERLAUBT = {
    standort: ['indoor', 'outdoor'],
    sortiment: ['snack', 'getraenke', 'kombi', 'tiefkuehl', 'kaffee', 'micro-market'],
    groesse: ['s', 'm', 'l'],
    bedienung: ['tasten', 'touch', 'egal'],
    bargeld: ['nein', 'ja'],
    erweitern: ['nein', 'ja']
  };
  // Aliasse fuer Deep-Links (Branchenseiten, Mega-Menue); Schluessel nach slug()
  var ALIAS = {
    innen: 'indoor', drinnen: 'indoor', aussen: 'outdoor', draussen: 'outdoor', ungeheizt: 'outdoor',
    snacks: 'snack', getraenk: 'getraenke', drinks: 'getraenke', beides: 'kombi', 'snacks-getraenke': 'kombi',
    'snacks-und-getraenke': 'kombi', frische: 'tiefkuehl', frozen: 'tiefkuehl', micromarket: 'micro-market',
    'non-food': 'micro-market', nonfood: 'micro-market', klein: 's', kompakt: 's', mittel: 'm', gross: 'l',
    touchdisplay: 'touch', tastatur: 'tasten', nein: 'nein', ja: 'ja'
  };
  var SCHWELLEN = { s: 40, l: 60 };
  var MAX_TREFFER = 3;
  var GROESSEN_RANG = { s: 0, m: 1, l: 2 };

  var SORTIMENT_REGELN = {
    // F-6: immer = Familien, die bei Standort Innen immer unter den Karten stehen (fehlt der X10, nimmt er die letzte
    // Stelle); immerVorzug = Vorzug fuer sie bei passender Groesse und nicht bei Bedienung "tasten", Grund wie kombi
    snack: { typen: ['snack', 'tisch'], ohne: ['kaffee'], immer: ['x10'], immerVorzug: true },
    getraenke: { typen: ['getraenke'] },
    // F-2: einGeraet = Familien mit Snacks und Getraenken in einem Geraet, die nicht typ:kombi tragen (Rang 0, Grund
    // TEXTE.grundEinGeraet); vorzug = vor den uebrigen Treffern gleichen Rangs, nicht bei Bedienung "tasten"
    kombi: {
      typen: ['kombi'],
      einGeraet: ['x10'],
      vorzug: ['x10'],
      // F-6: X10 immer unter den Karten (Vorzug und Grund wie seit F-2)
      immer: ['x10'],
      // KX-1: ohne Slave der slaveFamilie am Standort greift der Ersatz als ein Geraet (Hinweis auf einen Slave der
      // auswahlSlaveFamilie); daneben = bei Groesse "gross" ein Master dieses Typs und dieser Familie als zweite Karte
      ersatz: {
        typ: 'snack', familie: 'g-snack', slaveFamilie: 'g-drink', auswahlSlaveFamilie: 'g-snack',
        daneben: { typ: 'getraenke', familie: 'g-drink', groesse: 'l' }
      }
    },
    tiefkuehl: { typen: ['tiefkuehl'] },
    kaffee: { typen: ['kaffee'] },
    'micro-market': { typen: ['micro-market'], beratung: true }
  };
  var NIE_EMPFEHLEN_TYPEN = ['erweiterung', 'zahlungssystem', 'zubehoer', 'service'];
  // Woerter, die bei der Zuordnung Master -> Slave nicht zaehlen
  var STOPPWOERTER = ['sandenvendo', 'slave', 'erweiterung', 'und', 'mit', 'oder'];

  // Sichtbare Texte (Umlaute als \u-Escapes, die Datei bleibt ASCII; Laufzeit = echte Umlaute)
  var TEXTE = {
    // F-7: Satz ueber den gleichwertigen Karten (keine Empfehlung, kein Grund, keine Alternative mehr im Satz);
    // {anzahl} als Zahlwort aus anzahlWorte, sonst die Ziffer
    satzEins: 'Zu Ihren Angaben passt dieser Automat.',
    satzMehr: 'Zu Ihren Angaben passen diese {anzahl} Automaten.',
    anzahlWorte: { 2: 'zwei', 3: 'drei' },
    // F-7: Hinweis einer aufgefuellten Karte (Bedienung "Touchdisplay" gewaehlt, Geraet ohne Touchdisplay)
    ohneTouch: 'Dieses Ger\u00e4t hat kein Touchdisplay.',
    paket: 'Paket: ',
    paketKarte: 'Komplettpaket Karte',
    plusBargeld: ', plus Bargeld',
    trenner: ' \u00b7 ',
    // F-2: Grund fuer Familien der Regel kombi (einGeraet); Wortlaut aus KOL-03/GSBC-H-01, FAQ kue-x10 und dem
    // X10-Vorteil "Wechselbare Spiralen inklusive Dosenhalter" (Textbaukasten FIND-R-X10)
    grundEinGeraet: ['Snacks und Getr\u00e4nke in einem Ger\u00e4t', 'gek\u00fchlt', 'Dosenhalter'],
    getraenkeSlaveVor: 'Getr\u00e4nke erg\u00e4nzen Sie mit ',
    getraenkeSlaveNach: ' an derselben Kasse.',
    // KX-1: Grund des Ersatzes als ein Geraet (G-Snack-Master ohne G-Drink-Slave am Standort), Wortlaut aus KOL-03,
    // GSBC-H-01 und FIND-R-X10 ("Snacks und Getraenke in einem Geraet") und dem G-Snack-Baustein B-2 ("Dosen ... und
    // PET-Flaschen ... in Dosenhaltern", ohne Mengenangaben), keine Zahl; Hinweis auf den Slave des Ersatzes
    grundEinGeraetErsatz: ['Snacks und Getr\u00e4nke in einem Ger\u00e4t', 'Dosen und PET-Flaschen in Dosenhaltern'],
    auswahlSlaveVor: 'Weitere Snacks und Getr\u00e4nke erg\u00e4nzen Sie mit ',
    // KX-1: zweite Karte daneben (Getraenke-Master bei Groesse "gross"): Zusatz im Ergebnistext, Hinweis auf der Karte
    daneben: 'daneben f\u00fcr ein gro\u00dfes Getr\u00e4nkesortiment',
    danebenVor: 'F\u00fcr ein gro\u00dfes Getr\u00e4nkesortiment stellen Sie ihn neben den ',
    danebenNach: '.',
    slaveVor: 'Sp\u00e4ter erweiterbar mit ',
    slaveNach: ' \u2013 mehr Auswahl an derselben Kasse.',
    keineTreffer: 'F\u00fcr diese Angaben haben wir kein passendes Ger\u00e4t im Sortiment. Wir beraten Sie gern pers\u00f6nlich.',
    fortschritt: 'Schritt {n} von {gesamt}',
    status1: '1 passender Automat gefunden.',
    statusN: '{n} passende Automaten gefunden.',
    statusBeratung: 'Kein passendes Ger\u00e4t gefunden. Wir bieten Ihnen eine pers\u00f6nliche Beratung an.',
    variante: 'Variante ',
    auswahlen: ' Auswahlen',
    finderPraefix: 'Automaten-Finder: ',
    nachrichtAngebot: 'Bitte senden Sie mir ein Angebot f\u00fcr {produkt}. Meine Angaben im Automaten-Finder: {kriterien}.',
    nachrichtBeratung: 'Bitte beraten Sie mich zu einem passenden Automaten. Meine Angaben im Automaten-Finder: {kriterien}.'
  };

  var LABELS = {
    standort: { indoor: 'Innen', outdoor: 'Au\u00dfen oder ungeheizt' },
    sortiment: {
      snack: 'Snacks', getraenke: 'Getr\u00e4nke', kombi: 'Snacks und Getr\u00e4nke', tiefkuehl: 'Tiefk\u00fchl oder Frische',
      kaffee: 'Kaffee', 'micro-market': 'Non-Food oder sperrige Ware'
    },
    groesse: { s: 'Kompakt', m: 'Mittel', l: 'Gro\u00df' },
    bedienung: { tasten: 'Tasten gen\u00fcgen', touch: 'Touchdisplay', egal: 'Egal' },
    bargeld: { nein: 'nein', ja: 'ja' },
    erweitern: { nein: 'nein', ja: 'ja' }
  };
  var FRAGEN_KURZ = {
    standort: 'Standort', sortiment: 'Sortiment', groesse: 'Gr\u00f6\u00dfe', bedienung: 'Bedienung',
    bargeld: 'Bargeld', erweitern: 'Sp\u00e4ter erweitern'
  };

  function istObjekt(x) {
    return !!x && typeof x === 'object' && !Array.isArray(x);
  }

  function hat(o, k) {
    return Object.prototype.hasOwnProperty.call(o, k);
  }

  function text(x) {
    return x == null ? '' : String(x);
  }

  function enthaelt(liste, wert) {
    return liste.indexOf(wert) !== -1;
  }

  function eindeutig(liste) {
    var aus = [];
    for (var i = 0; i < liste.length; i++) {
      if (liste[i] && !enthaelt(aus, liste[i])) aus.push(liste[i]);
    }
    return aus;
  }

  // Kleinbuchstaben, Umlaute transliteriert, Akzente weg, alles andere zu "-"
  function slug(wert) {
    var s = text(wert).toLowerCase()
      .replace(/\u00e4/g, 'ae').replace(/\u00f6/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\u00df/g, 'ss');
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function dekodiere(s) {
    try {
      return decodeURIComponent(text(s).replace(/\+/g, ' '));
    } catch (e) {
      return text(s);
    }
  }

  function normWert(feld, wert) {
    var s = slug(wert);
    if (hat(ALIAS, s)) s = ALIAS[s];
    return enthaelt(ERLAUBT[feld], s) ? s : '';
  }

  function normalisiereKriterien(k) {
    var aus = {};
    if (!istObjekt(k)) return aus;
    for (var i = 0; i < FELDER.length; i++) {
      var w = normWert(FELDER[i], k[FELDER[i]]);
      if (w) aus[FELDER[i]] = w;
    }
    return aus;
  }

  function paareAus(suche) {
    var s = text(suche).replace(/^\?/, '');
    return s ? s.split('&') : [];
  }

  function kriterienAusSuche(suche) {
    var roh = {};
    var paare = paareAus(suche);
    for (var i = 0; i < paare.length; i++) {
      if (!paare[i]) continue;
      var gleich = paare[i].indexOf('=');
      var name = dekodiere(gleich === -1 ? paare[i] : paare[i].slice(0, gleich));
      if (!enthaelt(FELDER, name) || hat(roh, name)) continue;
      roh[name] = gleich === -1 ? '' : dekodiere(paare[i].slice(gleich + 1));
    }
    return normalisiereKriterien(roh);
  }

  // Fremde Parameter (preview_theme_id, utm_*) bleiben unveraendert vorn, die Finder-Felder folgen in fester Reihenfolge
  function sucheAusKriterien(suche, kriterien) {
    var k = normalisiereKriterien(kriterien);
    var teile = [];
    var paare = paareAus(suche);
    for (var i = 0; i < paare.length; i++) {
      if (!paare[i]) continue;
      var name = dekodiere(paare[i].split('=')[0]);
      if (!enthaelt(FELDER, name)) teile.push(paare[i]);
    }
    for (var j = 0; j < FELDER.length; j++) {
      if (k[FELDER[j]]) teile.push(FELDER[j] + '=' + encodeURIComponent(k[FELDER[j]]));
    }
    return teile.length ? '?' + teile.join('&') : '';
  }

  function schwellenVon(s) {
    var klein = Number(s && s.s);
    var gross = Number(s && s.l);
    if (!isFinite(klein) || klein < 1) klein = SCHWELLEN.s;
    if (!isFinite(gross) || gross < 1) gross = SCHWELLEN.l;
    if (gross < klein) gross = klein;
    return { s: klein, l: gross };
  }

  function groesseVon(auswahlen, schwellen) {
    if (auswahlen == null || auswahlen === '') return '';
    var n = Number(auswahlen);
    if (!isFinite(n) || n <= 0) return '';
    var sw = schwellenVon(schwellen);
    if (n < sw.s) return 's';
    if (n > sw.l) return 'l';
    return 'm';
  }

  function formatGanz(zahl) {
    return String(zahl).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  // Cent -> "6.350" bzw. "89,90"
  function formatPreis(cent) {
    var c = Math.round(Number(cent) || 0);
    var euro = Math.floor(c / 100);
    var rest = c % 100;
    return formatGanz(euro) + (rest ? ',' + (rest < 10 ? '0' : '') + rest : '');
  }

  // Cent -> "7.556,50" (immer zwei Nachkommastellen)
  function formatPreisGenau(cent) {
    var c = Math.round(Number(cent) || 0);
    var rest = c % 100;
    return formatGanz(Math.floor(c / 100)) + ',' + (rest < 10 ? '0' : '') + rest;
  }

  // Brutto = round(netto x 1,19; 2) in ganzen Cent ohne Gleitkomma-Rest
  function bruttoCent(cent) {
    return Math.round((Math.round(Number(cent) || 0) * 119) / 100);
  }

  var ABKUERZUNGEN = ['z', 'b', 'u', 'a', 'ca', 'bzw', 'inkl', 'max', 'min', 'zzgl', 'ggf', 'evtl', 'usw', 'nr', 'vgl', 'etc', 'd', 'h'];

  // Erster Satz eines Vorteils ("Titel. Text" -> "Titel"), Tausenderpunkte und Abkuerzungen trennen nicht
  function kurzFakt(eintrag) {
    var s = text(eintrag).replace(/\s+/g, ' ').trim();
    if (!s) return '';
    var strich = s.indexOf('|');
    if (strich > 0) s = s.slice(0, strich).trim();
    var re = /\.\s/g;
    var m;
    while ((m = re.exec(s))) {
      var davor = s.slice(0, m.index);
      var wort = davor.split(' ').pop().toLowerCase();
      if (davor.length >= 3 && !enthaelt(ABKUERZUNGEN, wort) && !/^\d+$/.test(wort)) {
        s = davor;
        break;
      }
    }
    return s.replace(/[\s.]+$/, '');
  }

  function tagWerte(tags, praefix) {
    var aus = [];
    for (var i = 0; i < tags.length; i++) {
      var t = text(tags[i]);
      var p = t.indexOf(':');
      if (p > 0 && slug(t.slice(0, p)) === praefix) aus.push(slug(t.slice(p + 1)));
    }
    return aus;
  }

  function normBedienung(wert) {
    var s = slug(wert);
    if (!s) return '';
    if (s.indexOf('touch') !== -1) return 'touch';
    if (s.indexOf('tast') !== -1) return 'tasten';
    return '';
  }

  function normalisiereVariante(v) {
    if (!istObjekt(v) || v.id == null || v.id === '') return null;
    var preis = Number(v.preis);
    if (!isFinite(preis) || preis < 0) return null;
    var titel = text(v.titel).trim();
    if (titel === 'Default Title') titel = '';
    var auswahlen = v.auswahlen == null || v.auswahlen === '' ? null : Number(v.auswahlen);
    if (auswahlen != null && (!isFinite(auswahlen) || auswahlen <= 0)) auswahlen = null;
    var aus = {
      id: v.id,
      titel: titel,
      modell: text(v.modell).trim(),
      auswahlen: auswahlen,
      kapazitaet: text(v.kapazitaet).trim(),
      preis: Math.round(preis),
      verfuegbar: v.verfuegbar !== false
    };
    // Paket E-L-2a: Energiedaten roh weitergeben (Pruefung und Markup in mv-sortiment.energielabel.js)
    if (istObjekt(v.energie)) aus.energie = v.energie;
    return aus;
  }

  function normalisiereProdukt(roh, index) {
    if (!istObjekt(roh) || !text(roh.handle)) return null;
    var tags = Array.isArray(roh.tags) ? roh.tags : [];
    var varianten = [];
    var rohVarianten = Array.isArray(roh.varianten) ? roh.varianten : [];
    for (var i = 0; i < rohVarianten.length; i++) {
      var v = normalisiereVariante(rohVarianten[i]);
      if (v) varianten.push(v);
    }
    var vorteile = [];
    var rohVorteile = Array.isArray(roh.vorteile) ? roh.vorteile : [];
    for (var j = 0; j < rohVorteile.length && vorteile.length < 2; j++) {
      var f = kurzFakt(rohVorteile[j]);
      if (f) vorteile.push(f);
    }
    var rollen = tagWerte(tags, 'rolle');
    var handle = text(roh.handle);
    return {
      index: typeof index === 'number' ? index : 0,
      handle: handle,
      title: text(roh.title) || handle,
      url: text(roh.url) || '/products/' + handle,
      bild: text(roh.bild),
      // F-7: Herstellerfoto mit breitem Weissrand (Datenblock bild_rand: HR-Rendering, Geraet rund 60 % der Bildhoehe) -
      // die Bildbuehne vergroessert es
      bildRand: roh.bild_rand === true,
      typen: eindeutig([slug(roh.typ)].concat(tagWerte(tags, 'typ'))),
      standorte: eindeutig([slug(roh.standort)].concat(tagWerte(tags, 'standort'))),
      bedienungen: eindeutig([normBedienung(roh.bedienung)].concat(tagWerte(tags, 'bedienung').map(normBedienung))),
      rolle: rollen[0] || '',
      familie: slug(roh.familie) || tagWerte(tags, 'familie')[0] || '',
      paket: enthaelt(tagWerte(tags, 'paket'), 'verfuegbar'),
      display: text(roh.display).split(', ')[0].trim(),
      lieferzeit: text(roh.lieferzeit).trim(),
      vorteile: vorteile,
      slave: text(roh.slave).trim(),
      varianten: varianten
    };
  }

  function produkteAus(daten) {
    var roh = Array.isArray(daten) ? daten : (istObjekt(daten) && Array.isArray(daten.produkte) ? daten.produkte : []);
    var aus = [];
    for (var i = 0; i < roh.length; i++) {
      var p = normalisiereProdukt(roh[i], i);
      if (p) aus.push(p);
    }
    return aus;
  }

  // Variante zur gewuenschten Groesse: passender Bucket, sonst naechster; dann verfuegbar, dann guenstiger
  function waehleVariante(produkt, groesse, schwellen) {
    var vs = produkt && Array.isArray(produkt.varianten) ? produkt.varianten : [];
    var ziel = hat(GROESSEN_RANG, groesse) ? GROESSEN_RANG[groesse] : -1;
    var beste = null;
    var besteSchluessel = null;
    for (var i = 0; i < vs.length; i++) {
      var g = groesseVon(vs[i].auswahlen, schwellen);
      var abstand = ziel === -1 ? 0 : (g ? Math.abs(GROESSEN_RANG[g] - ziel) : 9);
      var schluessel = [abstand, vs[i].verfuegbar ? 0 : 1, vs[i].preis, i];
      if (!beste || vergleicheListen(schluessel, besteSchluessel) < 0) {
        beste = vs[i];
        besteSchluessel = schluessel;
      }
    }
    if (!beste) return { variante: null, passt: false, abstand: 9 };
    return { variante: beste, passt: ziel !== -1 && besteSchluessel[0] === 0, abstand: besteSchluessel[0] };
  }

  function vergleicheListen(a, b) {
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return 0;
  }

  // Nur Master werden empfohlen; Slaves, Add-ons und Services nie
  function empfehlbar(p) {
    if (!p.varianten.length || p.rolle !== 'master') return false;
    for (var i = 0; i < NIE_EMPFEHLEN_TYPEN.length; i++) {
      if (enthaelt(p.typen, NIE_EMPFEHLEN_TYPEN[i])) return false;
    }
    return true;
  }

  function istSlave(p) {
    return p.rolle === 'slave' || enthaelt(p.typen, 'erweiterung');
  }

  // F-2: Familie der Regel, die Snacks und Getraenke in einem Geraet verkauft (X10), auch ohne den Typ der Regel
  function einGeraet(p, regel) {
    return !!regel.einGeraet && enthaelt(regel.einGeraet, p.familie) && !istSlave(p);
  }

  // 0 = Sortiment passt direkt (Typ oder Familie einGeraet), 1 = Ersatz (G-Snack-Master bei kombi), -1 = passt nicht
  function sortimentRang(p, regel) {
    var ohne = regel.ohne || [];
    for (var i = 0; i < ohne.length; i++) {
      if (enthaelt(p.typen, ohne[i])) return -1;
    }
    for (var j = 0; j < regel.typen.length; j++) {
      if (enthaelt(p.typen, regel.typen[j])) return 0;
    }
    if (einGeraet(p, regel)) return 0;
    var e = regel.ersatz;
    if (e && enthaelt(p.typen, e.typ) && p.familie === e.familie && !istSlave(p)) return 1;
    return -1;
  }

  function woerter(titel) {
    var liste = slug(titel).split('-');
    var aus = [];
    for (var i = 0; i < liste.length; i++) {
      if (liste[i].length > 1 && !enthaelt(STOPPWOERTER, liste[i]) && !enthaelt(aus, liste[i])) aus.push(liste[i]);
    }
    return aus;
  }

  function minPreis(p) {
    var m = Infinity;
    for (var i = 0; i < p.varianten.length; i++) m = Math.min(m, p.varianten[i].preis);
    return m;
  }

  // Slave einer Familie am Standort; bei mehreren der mit den meisten gemeinsamen Titelwoertern, dann der guenstigste
  function findeSlave(master, produkte, familie, standort) {
    var mw = woerter(master.title);
    var beste = null;
    var besteSchluessel = null;
    for (var i = 0; i < produkte.length; i++) {
      var s = produkte[i];
      if (!istSlave(s) || s.familie !== familie || !enthaelt(s.standorte, standort) || !s.varianten.length) continue;
      var sw = woerter(s.title);
      var gemeinsam = 0;
      for (var j = 0; j < sw.length; j++) {
        if (enthaelt(mw, sw[j])) gemeinsam++;
      }
      var schluessel = [-gemeinsam, minPreis(s), s.index];
      if (!beste || vergleicheListen(schluessel, besteSchluessel) < 0) {
        beste = s;
        besteSchluessel = schluessel;
      }
    }
    return beste;
  }

  // Slave laut Metafeld mv_vending.slave_produkt (nur wenn er in den Daten steht, sonst kein Hinweis)
  function slaveVon(p, produkte) {
    if (!p.slave) return null;
    for (var i = 0; i < produkte.length; i++) {
      if (produkte[i].handle === p.slave) return produkte[i];
    }
    return null;
  }

  function signatur(p) {
    var teile = [];
    for (var i = 0; i < p.varianten.length; i++) {
      var v = p.varianten[i];
      teile.push(v.titel + ':' + v.modell + ':' + v.preis);
    }
    return p.familie + '|' + teile.join(',');
  }

  function vergleicheTreffer(a, b) {
    return vergleicheListen(
      [a.rang, a.vorzug, -a.score, a.abstand, a.variante.preis, a.produkt.index],
      [b.rang, b.vorzug, -b.score, b.abstand, b.variante.preis, b.produkt.index]
    );
  }

  // F-6: Familie der Regel immer (X10), solange das Setting x10_immer nicht aus ist (immer = Liste oder null)
  function immerFamilie(p, immer) {
    return !!immer && enthaelt(immer, p.familie) && !istSlave(p);
  }

  // F-6: die ersten max Treffer mit einem Treffer der Familien immer: steht keiner unter den ersten max, nimmt der erste
  // dahinter die letzte Stelle (die uebrigen behalten ihre Reihenfolge, der bisher letzte faellt heraus); steht einer
  // schon darunter, bleibt alles, wie es ist (kein Zurueckstufen)
  function mitImmer(eindeutige, immer, max) {
    var vorn = eindeutige.slice(0, max);
    for (var i = 0; i < vorn.length; i++) {
      if (immerFamilie(vorn[i].produkt, immer)) return vorn;
    }
    for (var j = max; j < eindeutige.length; j++) {
      if (immerFamilie(eindeutige[j].produkt, immer)) return vorn.slice(0, max - 1).concat([eindeutige[j]]);
    }
    return vorn;
  }

  // KX-1: Karte neben dem Ersatz als ein Geraet - der passendste Master der Regel daneben (Typ und Familie) am Standort;
  // Bedienung "touch" filtert, Variante und Score wie bei den uebrigen Treffern; neben = Produkt der ersten Karte
  function danebenTreffer(produkte, k, daneben, schwellen, neben) {
    var beste = null;
    for (var i = 0; i < produkte.length; i++) {
      var p = produkte[i];
      if (!empfehlbar(p) || !enthaelt(p.standorte, k.standort) || !enthaelt(p.typen, daneben.typ) || p.familie !== daneben.familie) continue;
      if (k.bedienung === 'touch' && !enthaelt(p.bedienungen, 'touch')) continue;
      var wahl = waehleVariante(p, k.groesse, schwellen);
      if (!wahl.variante) continue;
      var bedienungPasst = (k.bedienung === 'touch' || k.bedienung === 'tasten') && enthaelt(p.bedienungen, k.bedienung);
      var t = {
        produkt: p,
        variante: wahl.variante,
        rang: 2,
        vorzug: 1,
        score: (bedienungPasst ? 2 : 0) + (wahl.passt ? 2 : 0),
        abstand: wahl.abstand,
        groessePasst: wahl.passt,
        bedienungPasst: bedienungPasst,
        rolle: '',
        grund: null,
        daneben: true,
        hinweise: { getraenkeSlave: null, slave: null, neben: neben }
      };
      if (!beste || vergleicheTreffer(t, beste) < 0) beste = t;
    }
    return beste;
  }

  function finde(daten, kriterien, optionen) {
    var o = istObjekt(optionen) ? optionen : {};
    var k = normalisiereKriterien(kriterien);
    var schwellen = schwellenVon(o.schwellen);
    var max = Number(o.max) > 0 ? Math.floor(Number(o.max)) : MAX_TREFFER;
    var produkte = produkteAus(daten);
    var regel = hat(SORTIMENT_REGELN, k.sortiment) ? SORTIMENT_REGELN[k.sortiment] : null;
    var kandidaten = [];
    // F-6: Familien der Regel immer (X10 innen bei snack und kombi); aus mit optionen.x10Immer === false (Setting
    // x10_immer der Sektion), dann wie vor F-6
    var immer = regel && regel.immer && o.x10Immer !== false ? regel.immer : null;

    if (k.standort && regel) {
      for (var i = 0; i < produkte.length; i++) {
        var p = produkte[i];
        if (!empfehlbar(p) || !enthaelt(p.standorte, k.standort)) continue;
        var rang = sortimentRang(p, regel);
        if (rang < 0) continue;
        var getraenkeSlave = null;
        // KX-1: ohne G-Drink-Slave am Standort der Ersatz als ein Geraet (nur mit auswahlSlaveFamilie in der Regel)
        var einGeraetErsatz = false;
        if (rang === 1) {
          getraenkeSlave = findeSlave(p, produkte, regel.ersatz.slaveFamilie, k.standort);
          if (!getraenkeSlave && !regel.ersatz.auswahlSlaveFamilie) continue;
          einGeraetErsatz = !getraenkeSlave;
        }
        // F-7: Bedienung "touch" filtert die Treffer weiter; Geraete ohne Touchdisplay kommen in die Reserve zum Auffuellen
        var nurTouch = k.bedienung === 'touch' && !enthaelt(p.bedienungen, 'touch');
        var wahl = waehleVariante(p, k.groesse, schwellen);
        if (!wahl.variante) continue;
        var bedienungPasst = (k.bedienung === 'touch' || k.bedienung === 'tasten') && enthaelt(p.bedienungen, k.bedienung);
        kandidaten.push({
          produkt: p,
          variante: wahl.variante,
          rang: rang,
          // F-2: 0 = Vorzug der Regel (X10 bei kombi), nicht bei Bedienung "tasten"; sonst 1
          // F-6: Vorzug auch fuer die Familien aus immer bei immerVorzug, wenn die Groesse passt (nie bei "tasten")
          vorzug: ((regel.vorzug && enthaelt(regel.vorzug, p.familie)) ||
            (regel.immerVorzug && immerFamilie(p, immer) && wahl.passt)) && k.bedienung !== 'tasten' ? 0 : 1,
          score: (bedienungPasst ? 2 : 0) + (wahl.passt ? 2 : 0),
          abstand: wahl.abstand,
          groessePasst: wahl.passt,
          bedienungPasst: bedienungPasst,
          // F-7: keine Rolle mehr; aufgefuellt = nur der Filter Bedienung "touch" schloss das Geraet aus (Reserve)
          aufgefuellt: nurTouch,
          // F-2: eigener Grund statt der Vorteile (Familie einGeraet), sonst null; seit F-7 als Haken auf der Karte
          // F-6: denselben Grund tragen die Familien aus immer (der X10 auch bei Snacks)
          grund: einGeraet(p, regel) || immerFamilie(p, immer) ? TEXTE.grundEinGeraet.slice() : null,
          hinweise: { getraenkeSlave: getraenkeSlave, slave: null }
        });
        // KX-1: Ersatz als ein Geraet - eigener Grund, Hinweis auf einen Slave der Familie auswahlSlaveFamilie am Standort
        if (einGeraetErsatz) {
          var ersatz = kandidaten[kandidaten.length - 1];
          ersatz.grund = TEXTE.grundEinGeraetErsatz.slice();
          ersatz.einGeraetErsatz = true;
          ersatz.hinweise.auswahlSlave = findeSlave(p, produkte, regel.ersatz.auswahlSlaveFamilie, k.standort);
        }
      }
    }

    // F-7: Reserve zum Auffuellen (nur Bedienung "touch" schloss sie aus) getrennt, beide nach der normalen Bewertung
    var reserve = kandidaten.filter(function (x) { return x.aufgefuellt; });
    kandidaten = kandidaten.filter(function (x) { return !x.aufgefuellt; });
    kandidaten.sort(vergleicheTreffer);
    reserve.sort(vergleicheTreffer);
    var gesehen = {};
    var eindeutige = [];
    for (var j = 0; j < kandidaten.length; j++) {
      var sig = kandidaten[j].produkt.familie ? signatur(kandidaten[j].produkt) : '#' + kandidaten[j].produkt.handle;
      if (hat(gesehen, sig)) continue;
      gesehen[sig] = true;
      eindeutige.push(kandidaten[j]);
    }

    // KX-1: Ersatz als ein Geraet vorn und Groesse daneben.groesse - der Master der Regel daneben als zweite Karte
    var daneben = regel && regel.ersatz && regel.ersatz.daneben;
    if (daneben && k.groesse === daneben.groesse && eindeutige.length && eindeutige[0].einGeraetErsatz) {
      var zweite = danebenTreffer(produkte, k, daneben, schwellen, eindeutige[0].produkt);
      if (zweite) eindeutige.splice(1, 0, zweite);
    }

    var treffer = eindeutige.slice(0, max);
    // F-6: ein Treffer der Familien immer steht immer unter den ersten max Karten (mitImmer)
    if (immer) treffer = mitImmer(eindeutige, immer, max);
    for (var t = 0; t < treffer.length; t++) {
      // F-7: keine Rolle (Empfehlung/Alternative) - gleichwertige Karten in der Reihenfolge der Bewertung; auch die Karte
      // daneben von KX-1 traegt kein Feld rolle mehr
      delete treffer[t].rolle;
      if (k.erweitern === 'ja') treffer[t].hinweise.slave = slaveVon(treffer[t].produkt, produkte);
      // KX-1: Hinweis auf den Slave des Ersatzes nicht bei "Spaeter erweitern: nein"; derselbe Slave nur einmal
      var hw = treffer[t].hinweise;
      if (hw.auswahlSlave && k.erweitern === 'nein') hw.auswahlSlave = null;
      if (hw.auswahlSlave && hw.slave && hw.slave.handle === hw.auswahlSlave.handle) hw.slave = null;
    }

    // F-7: weniger als max Karten -> auffuellen aus der Reserve (normale Bewertung, Farbgeschwister weiter einmal) mit
    // denselben Hinweisen wie oben; Standort und Sortiment bleiben Pflicht (weniger Geraete im Bestand: weniger Karten)
    var aufgefuellt = 0;
    for (var r = 0; r < reserve.length && treffer.length < max; r++) {
      var sigR = reserve[r].produkt.familie ? signatur(reserve[r].produkt) : '#' + reserve[r].produkt.handle;
      if (hat(gesehen, sigR)) continue;
      gesehen[sigR] = true;
      var zusatz = reserve[r];
      if (k.erweitern === 'ja') zusatz.hinweise.slave = slaveVon(zusatz.produkt, produkte);
      var hz = zusatz.hinweise;
      if (hz.auswahlSlave && k.erweitern === 'nein') hz.auswahlSlave = null;
      if (hz.auswahlSlave && hz.slave && hz.slave.handle === hz.auswahlSlave.handle) hz.slave = null;
      treffer.push(zusatz);
      aufgefuellt++;
    }

    var vollstaendig = true;
    for (var f = 0; f < PFLICHT.length; f++) {
      if (!k[PFLICHT[f]]) vollstaendig = false;
    }

    return {
      kriterien: k,
      vollstaendig: vollstaendig,
      treffer: treffer,
      anzahl: eindeutige.length,
      // F-7: so viele Karten kamen beim Auffuellen dazu (0 = jede Karte passt auch in der Bedienung)
      aufgefuellt: aufgefuellt,
      fallback: treffer.length === 0,
      beratung: treffer.length === 0 || !!(regel && regel.beratung)
    };
  }

  function variantenLabel(v) {
    if (!v) return '';
    if (v.titel && v.modell && v.titel !== v.modell) return v.titel + ' (' + v.modell + ')';
    return v.titel || v.modell;
  }

  function titelMitVariante(t) {
    var label = variantenLabel(t.variante);
    return t.produkt.title + (label ? ' ' + label : '');
  }

  // Hinweise einer Karte als Teile {vor, produkt, nach}; der Produktname wird im DOM verlinkt
  function hinweisTeile(t) {
    var aus = [];
    // F-7: aufgefuellte Karte (Bedienung "Touchdisplay" gewaehlt): Hinweis ohne Produkt, im DOM ohne Link
    if (t && t.aufgefuellt) aus.push({ vor: TEXTE.ohneTouch, produkt: null, nach: '' });
    if (t && t.hinweise && t.hinweise.getraenkeSlave) {
      aus.push({ vor: TEXTE.getraenkeSlaveVor, produkt: t.hinweise.getraenkeSlave, nach: TEXTE.getraenkeSlaveNach });
    }
    // KX-1: Slave des Ersatzes als ein Geraet, Hinweis der Karte daneben
    if (t && t.hinweise && t.hinweise.auswahlSlave) {
      aus.push({ vor: TEXTE.auswahlSlaveVor, produkt: t.hinweise.auswahlSlave, nach: TEXTE.getraenkeSlaveNach });
    }
    if (t && t.hinweise && t.hinweise.neben) {
      aus.push({ vor: TEXTE.danebenVor, produkt: t.hinweise.neben, nach: TEXTE.danebenNach });
    }
    if (t && t.hinweise && t.hinweise.slave) {
      aus.push({ vor: TEXTE.slaveVor, produkt: t.hinweise.slave, nach: TEXTE.slaveNach });
    }
    return aus;
  }

  function kartenHinweise(t) {
    var teile = hinweisTeile(t);
    var aus = [];
    // F-7: Hinweis ohne Produkt (aufgefuellte Karte) nur mit seinem Text
    for (var i = 0; i < teile.length; i++) aus.push(teile[i].vor + (teile[i].produkt ? teile[i].produkt.title : '') + teile[i].nach);
    return aus;
  }

  // F-7 (FIND-R ohne Hauptempfehlung): "Zu Ihren Angaben passen diese drei Automaten. Paket: Komplettpaket Karte{, plus
  // Bargeld}." - Anzahl als Zahlwort, Paket-Satz nur, wenn jede Karte das Komplettpaket hat; Fakten und Hinweise stehen
  // je auf ihrer Karte (kein Grund, keine Alternative und keine Hinweise der ersten Karte im Satz)
  function ergebnisText(erg, optionen) {
    var o = istObjekt(optionen) ? optionen : {};
    if (!erg || !Array.isArray(erg.treffer) || !erg.treffer.length) return text(o.keineTreffer) || TEXTE.keineTreffer;
    var k = erg.kriterien || {};
    var n = erg.treffer.length;
    var saetze = [n === 1 ? TEXTE.satzEins : TEXTE.satzMehr.replace('{anzahl}', hat(TEXTE.anzahlWorte, n) ? TEXTE.anzahlWorte[n] : String(n))];
    var allePaket = true;
    for (var i = 0; i < n; i++) {
      if (!erg.treffer[i].produkt.paket) allePaket = false;
    }
    if (allePaket) saetze.push(TEXTE.paket + TEXTE.paketKarte + (k.bargeld === 'ja' ? TEXTE.plusBargeld : '') + '.');
    return saetze.join(' ');
  }

  // "Standort: Innen - Sortiment: Snacks - ..." (Trenner Mittelpunkt) fuer Beratung und contact[Konfiguration]
  function kriterienText(kriterien, labels, kurz) {
    var k = normalisiereKriterien(kriterien);
    var l = istObjekt(labels) ? labels : {};
    var q = istObjekt(kurz) ? kurz : {};
    var teile = [];
    for (var i = 0; i < FELDER.length; i++) {
      var feld = FELDER[i];
      if (!k[feld]) continue;
      var eigen = istObjekt(l[feld]) && l[feld][k[feld]] ? l[feld][k[feld]] : '';
      var wert = eigen || LABELS[feld][k[feld]] || k[feld];
      teile.push((q[feld] || FRAGEN_KURZ[feld]) + ': ' + wert);
    }
    return teile.join(TEXTE.trenner);
  }

  function konfiguratorUrl(url, variantId) {
    var basis = text(url).split('#')[0];
    return basis + (basis.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(variantId) + '#mv-konfigurator';
  }

  // F-7: Fakten einer Karte als Haken - Grund des Treffers (F-2, F-6, KX-1), sonst die Vorteile des Produkts, sonst bei
  // einer Familie, die Snacks und Getraenke in einem Geraet verkauft (Regel kombi, einGeraet: der X10), deren Grund
  function fakten(t) {
    if (!t || !t.produkt) return [];
    if (t.grund && t.grund.length) return t.grund.slice();
    if (t.produkt.vorteile && t.produkt.vorteile.length) return t.produkt.vorteile.slice();
    if (enthaelt(SORTIMENT_REGELN.kombi.einGeraet, t.produkt.familie) && !istSlave(t.produkt)) return TEXTE.grundEinGeraet.slice();
    return [];
  }

  // F-7: Bildbreiten der Ergebniskarte; srcset aus einer Shopify-Bildadresse mit genau einem Parameter width (die Sektion
  // liefert image_url mit width), sonst leer (dann nur src); Adressen mit Leerzeichen oder Komma bleiben ohne srcset
  var BILD_BREITEN = [400, 600, 800, 1000, 1200];
  function bildSrcset(url) {
    var u = text(url);
    var muster = /([?&])width=\d+(?=&|#|$)/g;
    var treffer = u.match(muster);
    if (!treffer || treffer.length !== 1 || /[\s,]/.test(u)) return '';
    var teile = [];
    for (var i = 0; i < BILD_BREITEN.length; i++) teile.push(u.replace(muster, '$1width=' + BILD_BREITEN[i]) + ' ' + BILD_BREITEN[i] + 'w');
    return teile.join(', ');
  }

  var api = {
    FELDER: FELDER,
    PFLICHT: PFLICHT,
    ERLAUBT: ERLAUBT,
    TEXTE: TEXTE,
    LABELS: LABELS,
    FRAGEN_KURZ: FRAGEN_KURZ,
    SCHWELLEN: SCHWELLEN,
    normalisiereKriterien: normalisiereKriterien,
    kriterienAusSuche: kriterienAusSuche,
    sucheAusKriterien: sucheAusKriterien,
    groesseVon: groesseVon,
    formatPreis: formatPreis,
    formatPreisGenau: formatPreisGenau,
    bruttoCent: bruttoCent,
    kurzFakt: kurzFakt,
    normalisiereProdukt: normalisiereProdukt,
    waehleVariante: waehleVariante,
    finde: finde,
    variantenLabel: variantenLabel,
    titelMitVariante: titelMitVariante,
    hinweisTeile: hinweisTeile,
    kartenHinweise: kartenHinweise,
    ergebnisText: ergebnisText,
    kriterienText: kriterienText,
    konfiguratorUrl: konfiguratorUrl,
    // F-7
    fakten: fakten,
    bildSrcset: bildSrcset,
    BILD_BREITEN: BILD_BREITEN
  };

  // Node (Tests): nur hier gibt es module.exports, im Browser nie
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = api;
    return;
  }

  // ===========================================================================================
  // Teil 2: Browser
  // ===========================================================================================

  window.__mvSortiment = window.__mvSortiment || {};
  var MV = window.__mvSortiment;
  if (MV.finder) return;
  MV.finder = api;

  var GESAMT = PFLICHT.length;
  var instanzen = typeof WeakMap === 'function' ? new WeakMap() : null;
  var letzteEingabe = 'zeiger';
  var bewegungReduziert = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function publiziere(name, daten) {
    try {
      var s = window.Shopify;
      if (s && s.analytics && typeof s.analytics.publish === 'function') s.analytics.publish(name, daten);
    } catch (e) { /* Analytics darf den Finder nie stoppen */ }
  }

  function ersetze(vorlage, werte) {
    return text(vorlage).replace(/\{(\w+)\}/g, function (ganz, name) {
      return hat(werte, name) ? text(werte[name]) : ganz;
    });
  }

  function attr(el, name, ersatz) {
    var w = el ? el.getAttribute(name) : null;
    return w == null || w === '' ? ersatz : w;
  }

  function Finder(wurzel) {
    this.w = wurzel;
    this.form = wurzel.querySelector('[data-mv-finder-form]');
    this.schwellen = schwellenVon({ s: attr(wurzel, 'data-schwelle-s', ''), l: attr(wurzel, 'data-schwelle-l', '') });
    // F-6: Setting x10_immer der Sektion (data-x10-immer="false" schaltet die Regel ab; ohne Attribut gilt sie)
    this.x10Immer = attr(wurzel, 'data-x10-immer', '') !== 'false';
    this.kriterien = {};
    this.schritt = 1;
    this.daten = null;
    this.labels = null;
    this.letzterSchluessel = '';
    this.timer = 0;
  }

  Finder.prototype.el = function (selektor) {
    return this.w.querySelector(selektor);
  };

  Finder.prototype.alle = function (selektor) {
    return Array.prototype.slice.call(this.w.querySelectorAll(selektor));
  };

  Finder.prototype.datenLesen = function () {
    if (this.daten) return this.daten;
    var el = this.el('script[data-mv-finder-data]');
    var d = { produkte: [] };
    if (el) {
      try {
        d = JSON.parse(el.textContent || '{}');
      } catch (e) {
        if (window.console && console.warn) console.warn('mv-finder: Daten-JSON nicht lesbar', e);
      }
    }
    this.daten = d;
    return d;
  };

  // Antwort-Bezeichnungen aus dem Markup (Settings/Texte der Sektion gehen vor den Standardtexten)
  Finder.prototype.labelsLesen = function () {
    if (this.labels) return this.labels;
    var labels = {};
    var kurz = {};
    this.alle('input[type="radio"][name]').forEach(function (input) {
      var feld = input.name;
      if (!enthaelt(FELDER, feld)) return;
      var label = input.closest('label');
      var titel = label ? label.querySelector('[data-mv-finder-label]') : null;
      if (!labels[feld]) labels[feld] = {};
      if (titel && titel.textContent.trim()) labels[feld][input.value] = titel.textContent.trim();
    });
    this.alle('[data-mv-finder-frage][data-mv-finder-kurz]').forEach(function (fs) {
      kurz[fs.getAttribute('data-mv-finder-frage')] = fs.getAttribute('data-mv-finder-kurz');
    });
    this.labels = { werte: labels, kurz: kurz };
    return this.labels;
  };

  Finder.prototype.kriterienText = function () {
    var l = this.labelsLesen();
    return kriterienText(this.kriterien, l.werte, l.kurz);
  };

  Finder.prototype.radiosSetzen = function () {
    var k = this.kriterien;
    this.alle('input[type="radio"][name]').forEach(function (input) {
      if (!enthaelt(FELDER, input.name)) return;
      input.checked = k[input.name] === input.value;
    });
  };

  Finder.prototype.urlSchreiben = function () {
    try {
      var suche = sucheAusKriterien(window.location.search, this.kriterien);
      window.history.replaceState(window.history.state, '', window.location.pathname + suche + window.location.hash);
    } catch (e) { /* z. B. Sandbox-Iframe ohne History */ }
  };

  Finder.prototype.ersterOffenerSchritt = function (abSchritt) {
    for (var i = Math.max(1, abSchritt || 1); i <= GESAMT; i++) {
      if (!this.kriterien[PFLICHT[i - 1]]) return i;
    }
    return 0;
  };

  Finder.prototype.start = function () {
    this.kriterien = kriterienAusSuche(window.location.search);
    this.radiosSetzen();
    this.w.setAttribute('data-mv-finder-bereit', '');
    var offen = this.ersterOffenerSchritt(1);
    if (offen) this.zeigeSchritt(offen, false);
    else this.zeigeErgebnis(false);
  };

  Finder.prototype.fehler = function (zeigen) {
    var f = this.el('[data-mv-finder-fehler]');
    if (f) f.hidden = !zeigen;
  };

  Finder.prototype.fortschritt = function (stand, textInhalt) {
    this.w.setAttribute('data-mv-finder-stand', String(stand));
    var p = this.el('[data-mv-finder-fortschritt]');
    if (p) p.textContent = textInhalt;
  };

  Finder.prototype.zeigeSchritt = function (n, fokus) {
    this.schritt = n;
    var aktuell = null;
    this.alle('[data-mv-finder-schritt]').forEach(function (fs) {
      var ist = Number(fs.getAttribute('data-mv-finder-schritt')) === n;
      fs.hidden = !ist;
      if (ist) aktuell = fs;
    });
    var optional = this.el('[data-mv-finder-optional]');
    if (optional) optional.hidden = true;
    var erg = this.el('[data-mv-finder-ergebnis]');
    if (erg) erg.hidden = true;
    var zurueck = this.el('[data-mv-finder-zurueck]');
    if (zurueck) zurueck.hidden = n <= 1;
    var weiter = this.el('[data-mv-finder-weiter]');
    if (weiter) {
      weiter.hidden = false;
      weiter.textContent = n >= GESAMT ? attr(weiter, 'data-label-ergebnis', 'Empfehlung anzeigen') : attr(weiter, 'data-label-weiter', 'Weiter');
    }
    this.fehler(false);
    this.fortschritt(n, ersetze(attr(this.w, 'data-text-fortschritt', TEXTE.fortschritt), { n: n, gesamt: GESAMT }));
    if (fokus && aktuell) {
      try { aktuell.focus({ preventScroll: true }); } catch (e) { aktuell.focus(); }
      this.inSicht(aktuell);
    }
  };

  Finder.prototype.inSicht = function (el) {
    if (!el || !el.getBoundingClientRect || typeof el.scrollIntoView !== 'function') return;
    var r = el.getBoundingClientRect();
    if (r.top < 0 || r.top > (window.innerHeight || 0) * 0.6) {
      try { el.scrollIntoView({ block: 'start', behavior: bewegungReduziert ? 'auto' : 'smooth' }); } catch (e) { el.scrollIntoView(true); }
    }
  };

  Finder.prototype.weiter = function () {
    if (this.schritt > GESAMT) return;
    var feld = PFLICHT[this.schritt - 1];
    if (!this.kriterien[feld]) {
      this.fehler(true);
      var erstes = this.el('[data-mv-finder-schritt="' + this.schritt + '"] input[type="radio"]');
      if (erstes) erstes.focus();
      return;
    }
    var offen = this.ersterOffenerSchritt(this.schritt + 1);
    if (offen) this.zeigeSchritt(offen, true);
    else this.zeigeErgebnis(true);
  };

  Finder.prototype.zurueck = function () {
    if (this.schritt > GESAMT) this.zeigeSchritt(GESAMT, true);
    else if (this.schritt > 1) this.zeigeSchritt(this.schritt - 1, true);
  };

  Finder.prototype.neustart = function () {
    this.kriterien = {};
    this.radiosSetzen();
    this.urlSchreiben();
    this.letzterSchluessel = '';
    this.zeigeSchritt(1, true);
  };

  Finder.prototype.antwort = function (feld, wert) {
    var w = normWert(feld, wert);
    if (!w) return;
    this.kriterien[feld] = w;
    this.urlSchreiben();
    this.fehler(false);
    publiziere('finder_schritt', { schritt: FELDER.indexOf(feld) + 1, feld: feld, wert: w });
    if (this.schritt > GESAMT) this.rendern(false);
  };

  Finder.prototype.zeigeErgebnis = function (fokus) {
    this.schritt = GESAMT + 1;
    this.alle('[data-mv-finder-schritt]').forEach(function (fs) { fs.hidden = true; });
    var optional = this.el('[data-mv-finder-optional]');
    if (optional) optional.hidden = false;
    var zurueck = this.el('[data-mv-finder-zurueck]');
    if (zurueck) zurueck.hidden = false;
    var weiter = this.el('[data-mv-finder-weiter]');
    if (weiter) weiter.hidden = true;
    this.fehler(false);
    // F-7: Rueckfall wie das Setting fortschritt_ergebnis (keine Empfehlung)
    this.fortschritt('ergebnis', attr(this.w, 'data-text-ergebnis', 'Ergebnis'));
    var erg = this.el('[data-mv-finder-ergebnis]');
    if (erg) erg.hidden = false;
    this.rendern(true);
    var titel = this.el('[data-mv-finder-ergebnis-titel]');
    if (fokus && titel) {
      try { titel.focus({ preventScroll: true }); } catch (e) { titel.focus(); }
      this.inSicht(titel);
    }
  };

  function slot(el, name) {
    return el.querySelector('[data-mv-finder-slot="' + name + '"]');
  }

  function entferne(el) {
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  function setzeText(el, inhalt) {
    if (!el) return;
    if (inhalt) el.textContent = inhalt;
    else entferne(el);
  }

  function klon(vorlage) {
    if (!vorlage || !vorlage.content || !vorlage.content.firstElementChild) return null;
    return vorlage.content.firstElementChild.cloneNode(true);
  }

  Finder.prototype.karte = function (t, position, kriterienSatz) {
    var el = klon(this.el('template[data-mv-finder-vorlage="karte"]'));
    if (!el) return null;
    var p = t.produkt;
    var v = t.variante;
    var label = variantenLabel(v);
    var produktName = p.title + (label ? ' ' + label : '');
    var url = konfiguratorUrl(p.url, v.id);
    var karte = el.querySelector('[data-mv-finder-karte]') || el;

    // F-7 (Inhaber 14.10.2026: "Geb auf den Seiten keine Hauptempfehlung sondern immer 3"): gleichwertige Karten - kein
    // Reiter Empfehlung/Alternative und keine hervorgehobene erste Karte, auch mit einer Kartenvorlage vor F-7
    entferne(slot(el, 'badge-empfehlung'));
    entferne(slot(el, 'rolle'));
    if (t.aufgefuellt) karte.setAttribute('data-mv-finder-aufgefuellt', '');

    var bild = slot(el, 'bild');
    var platzhalter = slot(el, 'bild-platzhalter');
    if (p.bild && bild) {
      // F-7: srcset bis 1200 px aus der Adresse im Datenblock (sizes steht in der Kartenvorlage), vor src gesetzt
      var srcset = bildSrcset(p.bild);
      if (srcset) bild.setAttribute('srcset', srcset);
      bild.setAttribute('src', p.bild);
      // F-7: Herstellerfoto mit breitem Weissrand - die Buehne vergroessert es (mv-sortiment.f2.css)
      if (p.bildRand && bild.parentNode) bild.parentNode.setAttribute('data-mv-finder-bildrand', '');
      entferne(platzhalter);
    } else {
      entferne(bild);
      setzeText(platzhalter, p.title.replace(/^SandenVendo\s+/, ''));
    }

    var titel = slot(el, 'titel');
    if (titel) {
      titel.textContent = p.title;
      titel.setAttribute('href', url);
      titel.setAttribute('data-mv-handle', p.handle);
      titel.setAttribute('data-mv-variant-id', String(v.id));
      titel.setAttribute('data-mv-position', String(position + 1));
    }

    setzeText(slot(el, 'modell'), label ? TEXTE.variante + label : '');
    var kennzahlen = [];
    if (v.auswahlen) kennzahlen.push(v.auswahlen + TEXTE.auswahlen);
    if (v.kapazitaet) kennzahlen.push(v.kapazitaet);
    if (p.display) kennzahlen.push(p.display);
    setzeText(slot(el, 'kennzahlen'), kennzahlen.join(TEXTE.trenner));

    setzeText(slot(el, 'preis'), formatPreis(v.preis));
    setzeText(slot(el, 'brutto'), formatPreisGenau(bruttoCent(v.preis)));
    // Paket E-L-2a: Klassenpfeil und Produktdatenblatt der Variante (Knoten aus mv-sortiment.energielabel.js), sonst kein Platz
    var energie = el.querySelector('[data-mv-energie-finder]');
    if (energie) {
      var el2 = window.__mvSortiment && window.__mvSortiment.energielabel;
      var knoten = v.energie && el2 && el2.karteKnoten ? el2.karteKnoten(v.energie, energie.ownerDocument) : null;
      if (knoten) energie.appendChild(knoten);
      else entferne(energie);
    }
    setzeText(slot(el, 'lieferzeit'), p.lieferzeit);

    var vorteile = slot(el, 'vorteile');
    if (vorteile) {
      // F-7: jede Karte mit ihren eigenen Fakten als Haken (fakten(): Grund des Treffers, sonst die Vorteile)
      var liste = fakten(t);
      if (liste.length) {
        var vorlage = vorteile.firstElementChild;
        while (vorteile.firstChild) vorteile.removeChild(vorteile.firstChild);
        for (var i = 0; i < liste.length; i++) {
          var li = vorlage ? vorlage.cloneNode(false) : document.createElement('li');
          li.textContent = liste[i];
          vorteile.appendChild(li);
        }
      } else {
        entferne(vorteile);
      }
    }

    var hinweisBox = slot(el, 'hinweise');
    if (hinweisBox) {
      var teile = hinweisTeile(t);
      var hinweisVorlage = hinweisBox.firstElementChild;
      while (hinweisBox.firstChild) hinweisBox.removeChild(hinweisBox.firstChild);
      for (var h = 0; h < teile.length; h++) {
        var zeile = hinweisVorlage ? hinweisVorlage.cloneNode(false) : document.createElement('p');
        zeile.appendChild(document.createTextNode(teile[h].vor));
        // F-7: Hinweis ohne Produkt (aufgefuellte Karte) ohne Link
        if (teile[h].produkt) {
          var a = document.createElement('a');
          a.href = teile[h].produkt.url;
          a.textContent = teile[h].produkt.title;
          zeile.appendChild(a);
        }
        zeile.appendChild(document.createTextNode(teile[h].nach));
        hinweisBox.appendChild(zeile);
      }
      if (!teile.length) entferne(hinweisBox);
    }

    var konfig = slot(el, 'konfigurieren');
    if (konfig) {
      konfig.setAttribute('href', url);
      konfig.setAttribute('data-mv-handle', p.handle);
      konfig.setAttribute('data-mv-variant-id', String(v.id));
      konfig.setAttribute('data-mv-position', String(position + 1));
      konfig.setAttribute('aria-label', attr(konfig, 'data-label', konfig.textContent.trim()) + ': ' + produktName);
    }

    var angebot = slot(el, 'angebot');
    if (angebot) {
      var interesse = attr(angebot, 'data-interesse', 'Kauf');
      angebot.setAttribute('data-produkt', produktName);
      angebot.setAttribute('data-konfiguration', TEXTE.finderPraefix + kriterienSatz + TEXTE.trenner + produktName);
      angebot.setAttribute('data-mv-handle', p.handle);
      angebot.setAttribute('data-mv-variant-id', String(v.id));
      angebot.setAttribute('data-mv-position', String(position + 1));
      angebot.setAttribute('aria-label', attr(angebot, 'data-label', angebot.textContent.trim()) + ': ' + produktName);
      angebot.setAttribute('href', '/pages/contact?anfrage=1&interesse=' + encodeURIComponent(interesse) + '&produkt=' + encodeURIComponent(produktName));
    }
    return el;
  };

  Finder.prototype.beratungsKarte = function (kriterienSatz) {
    var el = klon(this.el('template[data-mv-finder-vorlage="beratung"]'));
    if (!el) return null;
    setzeText(slot(el, 'kriterien'), kriterienSatz);
    var cta = el.querySelector('[data-mv-finder-cta="beratung"]');
    if (cta) this.beratungsZiel(cta, kriterienSatz);
    return el;
  };

  Finder.prototype.beratungsZiel = function (cta, kriterienSatz) {
    var interesse = attr(cta, 'data-interesse', 'Beratung');
    var produkt = attr(cta, 'data-produkt', 'Automaten-Finder');
    cta.setAttribute('data-konfiguration', TEXTE.finderPraefix + kriterienSatz);
    cta.setAttribute('href', '/pages/contact?anfrage=1&interesse=' + encodeURIComponent(interesse) + '&produkt=' + encodeURIComponent(produkt));
  };

  Finder.prototype.rendern = function (meldenBeiNeuemErgebnis) {
    // F-6: Setting x10_immer an die Logik
    var erg = finde(this.datenLesen(), this.kriterien, { schwellen: this.schwellen, x10Immer: this.x10Immer });
    var kriterienSatz = this.kriterienText();
    var textEl = this.el('[data-mv-finder-text]');
    if (textEl) textEl.textContent = ergebnisText(erg, { keineTreffer: attr(this.w, 'data-text-keine-treffer', '') });

    var liste = this.el('[data-mv-finder-karten]');
    if (liste) {
      while (liste.firstChild) liste.removeChild(liste.firstChild);
      for (var i = 0; i < erg.treffer.length; i++) {
        var karte = this.karte(erg.treffer[i], i, kriterienSatz);
        if (karte) liste.appendChild(karte);
      }
      if (erg.beratung) {
        var beratung = this.beratungsKarte(kriterienSatz);
        if (beratung) liste.appendChild(beratung);
      }
      liste.setAttribute('data-mv-finder-anzahl', String(liste.children.length));
    }

    var zeile = this.el('[data-mv-finder-beratung-zeile]');
    if (zeile) {
      zeile.hidden = erg.beratung;
      var cta = zeile.querySelector('[data-mv-finder-cta="beratung"]');
      if (cta) this.beratungsZiel(cta, kriterienSatz);
    }

    var status = this.el('[data-mv-finder-status]');
    if (status) {
      status.textContent = erg.fallback ? TEXTE.statusBeratung
        : (erg.treffer.length === 1 ? TEXTE.status1 : ersetze(TEXTE.statusN, { n: erg.treffer.length }));
    }

    var handles = erg.treffer.map(function (t) { return t.produkt.handle; });
    var kriterien = {};
    FELDER.forEach(function (f) { kriterien[f] = erg.kriterien[f] || ''; });
    var schluessel = PFLICHT.map(function (f) { return kriterien[f]; }).join('|');
    if (meldenBeiNeuemErgebnis !== false && schluessel !== this.letzterSchluessel) {
      this.letzterSchluessel = schluessel;
      publiziere('finder_ergebnis', { kriterien: kriterien, treffer: handles, top: handles[0] || null, fallback: erg.fallback });
    }
    try {
      this.w.dispatchEvent(new CustomEvent('mv:finder:ergebnis', {
        bubbles: true,
        detail: {
          kriterien: kriterien,
          treffer: erg.treffer.map(function (t) {
            // F-7: keine Rolle mehr; aufgefuellt wie im Ergebnis
            return { handle: t.produkt.handle, variant_id: t.variante.id, preis: t.variante.preis, score: t.score, aufgefuellt: !!t.aufgefuellt };
          }),
          top: handles[0] || null,
          fallback: erg.fallback,
          beratung: erg.beratung,
          text: textEl ? textEl.textContent : ''
        }
      }));
    } catch (e) { /* alte Browser ohne CustomEvent-Konstruktor */ }
  };

  // Nachricht der Lightbox vorbelegen, solange der Kunde noch nichts Eigenes geschrieben hat
  function nachrichtVorbelegen(nachricht) {
    var dlg = document.getElementById('mv-anfrage');
    var feld = dlg ? dlg.querySelector('textarea[name="contact[body]"]') : null;
    if (!feld) return;
    var vorher = feld.getAttribute('data-mv-finder-vorbelegt');
    if (feld.value && feld.value !== vorher) return;
    feld.value = nachricht;
    feld.setAttribute('data-mv-finder-vorbelegt', nachricht);
  }

  function instanz(wurzel) {
    if (!wurzel) return null;
    var f = instanzen ? instanzen.get(wurzel) : wurzel.__mvFinder;
    if (f) return f;
    f = new Finder(wurzel);
    if (instanzen) instanzen.set(wurzel, f);
    else wurzel.__mvFinder = f;
    try {
      f.start();
    } catch (e) {
      if (window.console && console.error) console.error('mv-finder: Start fehlgeschlagen', e);
    }
    return f;
  }

  function wurzelVon(ziel) {
    return ziel && ziel.closest ? ziel.closest('[data-mv-finder]') : null;
  }

  function alleStarten(bereich) {
    var liste = (bereich || document).querySelectorAll('[data-mv-finder]');
    for (var i = 0; i < liste.length; i++) instanz(liste[i]);
  }

  document.addEventListener('pointerdown', function () { letzteEingabe = 'zeiger'; }, true);
  document.addEventListener('keydown', function () { letzteEingabe = 'tastatur'; }, true);

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio' || !enthaelt(FELDER, input.name)) return;
    var f = instanz(wurzelVon(input));
    if (f && input.checked) f.antwort(input.name, input.value);
  });

  // Zeiger-Klick auf eine Antwort springt zum naechsten Schritt; Tastatur bleibt stehen (Enter oder "Weiter")
  document.addEventListener('click', function (e) {
    var ziel = e.target;
    var wurzel = wurzelVon(ziel);
    if (!wurzel) return;
    var f = instanz(wurzel);
    if (!f) return;

    if (ziel.closest('[data-mv-finder-zurueck]')) {
      e.preventDefault();
      f.zurueck();
      return;
    }
    if (ziel.closest('[data-mv-finder-neustart]')) {
      e.preventDefault();
      f.neustart();
      return;
    }

    var cta = ziel.closest('[data-mv-finder-cta]');
    if (cta) {
      var zielArt = cta.getAttribute('data-mv-finder-cta');
      publiziere('finder_cta', {
        ziel: zielArt,
        handle: cta.getAttribute('data-mv-handle') || null,
        variant_id: Number(cta.getAttribute('data-mv-variant-id')) || null,
        position: Number(cta.getAttribute('data-mv-position')) || null
      });
      if (zielArt === 'beratung' || zielArt === 'angebot') {
        var satz = f.kriterienText();
        nachrichtVorbelegen(zielArt === 'beratung'
          ? ersetze(TEXTE.nachrichtBeratung, { kriterien: satz })
          : ersetze(TEXTE.nachrichtAngebot, { produkt: cta.getAttribute('data-produkt') || '', kriterien: satz }));
      }
      return;
    }

    var option = ziel.closest('label');
    var schrittEl = option ? option.closest('[data-mv-finder-schritt]') : null;
    if (!schrittEl || letzteEingabe !== 'zeiger') return;
    var n = Number(schrittEl.getAttribute('data-mv-finder-schritt'));
    if (n !== f.schritt || f.timer) return;
    f.timer = window.setTimeout(function () {
      f.timer = 0;
      if (f.schritt === n && f.kriterien[PFLICHT[n - 1]]) f.weiter();
    }, 160);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-mv-finder-form]')) return;
    e.preventDefault();
    var f = instanz(wurzelVon(form));
    if (f && f.schritt <= GESAMT) f.weiter();
  });

  document.addEventListener('shopify:section:load', function (e) {
    alleStarten(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { alleStarten(document); });
  } else {
    alleStarten(document);
  }
})();
